import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Dumbbell, Eye, QrCode, Users, Repeat, Bell } from "lucide-react";
import { Button } from "../components/ui/button";

const points = [
  { icon: <Dumbbell className="w-5 h-5" />, t: "Member retention dashboard", b: "Surface members at risk of churn — from their own self-reports." },
  { icon: <Eye className="w-5 h-5" />, t: "Lead reveal logic", b: "Reveal contact details only for members who opted in for support." },
  { icon: <QrCode className="w-5 h-5" />, t: "Unique audit links + QR", b: "Drop a link or print a QR code at reception. We track everything." },
  { icon: <Users className="w-5 h-5" />, t: "Tiered lead segmentation", b: "Critical, Exposed, Performing, Elite — outreach the right people first." },
  { icon: <Repeat className="w-5 h-5" />, t: "Re-engagement intelligence", b: "Run quarterly re-audits to measure progress and prove value." },
  { icon: <Bell className="w-5 h-5" />, t: "Automated Re-engagement Triggers", b: "Auto-flag members who slip a tier between audits so your team can step in early." },
];

export default function ForGyms() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="for-gyms-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
        <span className="eyebrow">For Gyms</span>
        <h1 className="font-display tracking-tighter text-5xl sm:text-6xl mt-4 leading-[1.05]">
          Turn wellness conversations into recurring revenue.
        </h1>
        <p className="text-lg text-slate-300 mt-6 leading-relaxed">
          Fitest helps boutique studios and large gym groups identify members who need support,
          re-engage them with permission, and prove the impact to ownership.
        </p>
        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/request-demo">
            <Button className="btn-glow rounded-full h-12 px-7" data-testid="gym-cta-demo">Request Demo</Button>
          </Link>
          <Link to="/pricing">
            <Button className="btn-ghost-bordered rounded-full h-12 px-7" data-testid="gym-cta-pricing">Gym Licence</Button>
          </Link>
        </div>
      </motion.div>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {points.map((p, idx) => (
          <div key={p.t} className="glass rounded-2xl p-6" data-testid={`gym-point-${idx}`}>
            <div className="w-10 h-10 grid place-items-center rounded-lg bg-white/5 border border-white/10 text-brand mb-5">
              {p.icon}
            </div>
            <h3 className="font-display text-lg mb-2">{p.t}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{p.b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
